"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mitt_1 = require("mitt");
var mitter = (0, mitt_1.default)();
exports.default = mitter;
